// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ubYed","right":"Footer_right__1Xmnq","buttons":"Footer_buttons__295Hq"};